import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormInput from '../FormInput';
import * as validateService from '~/services/validate';
import Config from '~/config';

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Mail address required';
  } else if (!validateService.validateEmail(values.email)) {
    errors.email = 'Mail address invalid';
  }
  return errors;
};

const styles = {
  iconLoading: {
    fontSize: 22,
    marginRight: 7,
  },
};

const ForgotPasswordForm = (props) => {
  const { handleSubmit, pristine, reset, submitting, t } = props;
  return (
    <form onSubmit={handleSubmit} className="forgot-password-form">
      <Field
        name="email"
        type="email"
        require
        component={FormInput}
        placeholder={t('Mail address')}
      />
      <button
        className={`btn btn-ac-primary btn-${Config.serviceType} btn-block btn-dialog-action`}
        disabled={pristine || submitting}
      >
        {submitting && (
          <FontAwesomeIcon style={styles.iconLoading} icon={faSpinner} pulse />
        )}
        {t('confirm')}
      </button>
      <style jsx global>
        {`
          .forgot-password-form {
            padding: 20px 55px;
          }
          .forgot-password-form a {
            cursor: pointer;
            color: #ffa823;
            user-select: none;
          }
          .forgot-password-form a:hover {
            color: #ffa823;
            text-decoration: none;
          }
        `}
      </style>
    </form>
  );
};

export default reduxForm({
  form: 'forgotPasswordForm',
  validate,
})(ForgotPasswordForm);
